/**
 * Purpose: Sticky bottom conversion bar on mobile — Call / WhatsApp for
 *          visitors, Edit for owners. Hidden on lg+ where the hero actions are
 *          always visible.
 * Inputs: business, canManage.
 * Outputs: fixed bottom bar (safe-area aware) or null when there is no action.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CTAButton } from '../../ui';
import { getBusinessContacts, contactsOfKind, primaryWhatsAppUrl } from '../../../utils/contacts';

const MobileBottomCTA = ({ business, canManage = false }) => {
  const navigate = useNavigate();
  const contacts = getBusinessContacts(business);
  const phone = contactsOfKind(contacts, 'phone')[0]?.value || null;
  const whatsAppHref = primaryWhatsAppUrl(contacts);

  if (!canManage && !phone) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 border-t border-gray-200 bg-white/95 px-4 py-3 backdrop-blur transition-transform dark:border-gray-700 dark:bg-gray-900/95 lg:hidden"
      style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))' }}
    >
      <div className="mx-auto flex max-w-lg gap-2">
        {canManage ? (
          <CTAButton
            fullWidth
            onClick={() => navigate(`/businesses/${business.slug || business.id}/edit`)}
          >
            Edit business
          </CTAButton>
        ) : (
          <>
            {phone && (
              <CTAButton fullWidth href={`tel:${phone}`} aria-label={`Call ${business.name}`}>
                Call now
              </CTAButton>
            )}
            {whatsAppHref && (
              <CTAButton
                fullWidth
                variant="secondary"
                href={whatsAppHref}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`WhatsApp ${business.name}`}
              >
                WhatsApp
              </CTAButton>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MobileBottomCTA;
